<app-side-menu>
  <div class="par-wrap">
    <div class="par-header mb-3">
      <div>
        <h1 class="par-title">
          <i class="fas fa-layer-group me-2"></i>
          Faixas de aprovação de preço
        </h1>
        <p class="par-subtitle text-muted mb-0">
          Regras de aprovação conforme faixa de valor nas compras.
        </p>
      </div>
      <button type="button" class="btn btn-primary" (click)="openCreate()">
        <i class="fas fa-plus me-1"></i>
        Nova faixa
      </button>
    </div>

    <div *ngIf="errorMessage" class="alert alert-warning">{{ errorMessage }}</div>

    <app-table
      [title]="'Faixas cadastradas'"
      [data]="rows"
      [columns]="columns"
      [actions]="actions"
      [loading]="loading"
      [showSearch]="false"
      [clickable]="false"
      [disablePagination]="false"
      [itemsPerPage]="pageSize"
      [totalItemsFromBackend]="totalItems"
      [currentPageFromBackend]="currentPage"
      (pageChange)="onPageChange($event)"
      (actionClick)="handleAction($event)">
    </app-table>
  </div>
</app-side-menu>
